export const C_KYC_LIMIT = [2000, 100000, 500000];
export const C_KYC_APPROACHING_THRESHOLD = 0.95;
